var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-sidebar',{attrs:{"id":"sidebar-right-g","right":"","shadow":"","title":"Typographie","visible":_vm.visible}},[_vm._t("tt-editor")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }